import React from 'react';
import cn from 'classnames';

import Card from '../Card';

import * as styles from './Quote.module.css';

const Quote = ({ text, author, subline, id, ...rest }) => {
  return (
    <Card
      id={id}
      animate
      className={cn(styles.root)}
      title="Una cita"
      {...rest}
    >
      <blockquote className={cn(styles.quote)}>
        <div className={cn(styles.text)}>{text}</div>
        <footer className={cn(styles.author)}>
          <span className={cn(styles.authorName)}>{author}</span>
          {subline && (
            <span className={cn(styles.authorSubline)}>{subline}</span>
          )}
        </footer>
      </blockquote>
    </Card>
  );
};

export default Quote;
